import React from 'react'
import { Formik, Form } from 'formik'
import {
  InputField,
  InputSelectOptions,
  LoaderButton
} from 'components/molecules'
import PropTypes from 'prop-types'
import {
  sellerInboundsTextInputFields,
  sellerInboundsSelectInputFields,
  sellerInboundsDateInputFields
} from './seller-inbound-filter-form-fieds'

const PER_PAGE = {
  10  : '10',
  25  : '25',
  50  : '50',
  100 : '100'
}

const propTypes = {
  filterValues       : PropTypes.object.isRequired,
  onClickSubmitForm  : PropTypes.func.isRequired,
  onClickReset       : PropTypes.func.isRequired,
  showCustomerFields : PropTypes.bool,
  hiddenColumns      : PropTypes.array
}

const defaultProps = {
  hiddenColumns: []
}

/**
 * Form to filters Seller::Inbound data
 * @param {Object} filterValues - current url filter values
 * @param {Function} onClickSubmitForm - function to submit form
 * @param {Function} onClickReset - function to reset form
 * @param {Array<String>} hiddenColumns - Array of hidden columns name so we can hide unnecessary filter
 */

const SellerInboundFilterForm = ({
  filterValues,
  onClickSubmitForm,
  onClickReset,
  hiddenColumns
}) => (
  <Formik
    initialValues={{
      per_page                     : filterValues.per_page || 10,
      code                         : filterValues.code || '',
      delivery_method              : filterValues.delivery_method || '',
      requested_date               : filterValues.requested_date || '',
      received_status              : filterValues.received_status || '',
      curation_status              : filterValues.curation_status || '',
      confirmation_status          : filterValues.confirmation_status || '',
      live_process_status          : filterValues.live_process_status || '',
      received_date                : filterValues.received_date || '',
      seller_type                  : filterValues.seller_type || '',
      seller_name                  : filterValues.seller_name || '',
      seller_code                  : filterValues.seller_code || '',
      seller_email                 : filterValues.email || '',
      seller_mobile                : filterValues.seller_mobile || '',
      pickup_scheduled             : filterValues.pickup_scheduled || '',
      pickup_scheduled_date        : filterValues.pickup_scheduled_date || '',
      gender                       : filterValues.gender || '',
      notes                        : filterValues.notes || '',
      tl_brand_classification_name : filterValues.tl_brand_classification_name || ''
    }}
    enableReinitialize={ true }
    onSubmit={ onClickSubmitForm }
  >
    {
      (formikProps) => (
        <Form>
          <div className='d-flex flex-wrap mt-3'>

            {
              sellerInboundsTextInputFields.map((inputField) => {
                if (!hiddenColumns.includes(inputField?.name)) {
                  return (
                    <InputField
                      formGroupClassName={ inputField.className || 'pr-3' }
                      key={ `request-pickup-filter-form-field-${inputField?.name}` }
                      type='text'
                      name={ inputField?.name }
                      label={ inputField?.label }
                      placeholder={ inputField?.placeholder }
                      bsSize={ 'sm' }
                    />
                  )
                }
              })
            }

          </div>

          <div className='d-flex flex-wrap'>
            {
              sellerInboundsDateInputFields.map((inputField) => {
                if (!hiddenColumns.includes(inputField?.name)) {
                  return (
                    <InputField
                      type='date'
                      key={ `request-pickup-filter-form-field-${inputField?.name}` }
                      label={ inputField.label }
                      name={ inputField.name }
                      formGroupClassName='pr-3'
                    />)
                }
              })
            }

          </div>

          <div className='d-flex flex-wrap'>

            {
              sellerInboundsSelectInputFields.map((inputField) => {
                if (!hiddenColumns.includes(inputField?.name)) {
                  return (
                    <InputField
                      key={ `request-pickup-filter-form-field-${inputField?.name}` }
                      type='select'
                      name={ inputField?.name }
                      label={ inputField?.label }
                      bsSize={ 'sm' }
                      formGroupClassName='mr-3'
                    >
                      { inputField.children }
                    </InputField>
                  )
                }
              })
            }
            <InputField
              type='select'
              name='per_page'
              label='Per Page'
              bsSize={ 'sm' }
              formGroupClassName='ml-auto'
            >
              <InputSelectOptions
                options={ PER_PAGE }
              />
            </InputField>
          </div>

          <LoaderButton
            color='primary'
            className='mt-auto'
            type='submit'
            disabled={ formikProps.isSubmitting }
            isLoading={ formikProps.isSubmitting }
            text='Filter'
          />
          <LoaderButton
            color='danger'
            disabled={ formikProps.isSubmitting }
            isLoading={ formikProps.isSubmitting }
            text='Reset'
            onClick={ onClickReset }
          />
        </Form>
      )
    }
  </Formik>
)

SellerInboundFilterForm.propTypes    = propTypes
SellerInboundFilterForm.defaultProps = defaultProps

export default SellerInboundFilterForm
